import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { FlexRow, FreeformTextRow } from '@app/flex-framework/flex-api.model';
import { ResourceImageService } from '@app/shared/services/resource-image/resource-image.service';
import { ProxyImageOptions } from '@app/thumbnails/thumbnail.model';
import { ThumbnailService } from '@app/thumbnails/thumbnail.service';
import { ImagePosition } from '@app/uploader/uploader-api.model';

@Component({
  selector: 'dgx-free-text-row',
  templateUrl: './free-text-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreeTextRowComponent implements OnChanges {
  @Input() public row: FlexRow;
  public rowTextDetails: FreeformTextRow;
  public imageUrl: string = '';
  public imagePosition: ImagePosition;
  public altText: string = '';

  constructor(
    private cdr: ChangeDetectorRef,
    private resourceImageService: ResourceImageService,
    private thumbnailService: ThumbnailService
  ) {}

  public ngOnChanges({ row }: SimpleChanges) {
    if (row && this.row?.targetResources) {
      this.setupRowData(this.row.targetResources[0]?.reference);
      this.cdr.markForCheck();
    }
  }

  public setupRowData(row: FreeformTextRow) {
    this.rowTextDetails = row;

    const image = this.row.section.imageUrl;
    // If there is no image the backend will send a dummy string,
    // we're filtering those out here.
    if (image && image !== 'ImageUrl') {
      const { imageUrl, position, altText, cropperCoordinates } =
        this.resourceImageService.parseImageUrl(image);

      const options: ProxyImageOptions = {
        imageSrc: imageUrl,
        method: 'fetch',
        crop: 'crop',
        cropCoordinates: cropperCoordinates,
      };

      const url = this.thumbnailService.fetchProxyImageSrcset(options);

      this.imageUrl = url.orig;
      this.imagePosition = position;
      this.altText = altText;
    } else {
      // there is no image so we need to ensure that any existing image prior to editing gets cleared out for the section.
      this.imageUrl = null;
    }
  }
}
